// extracted by mini-css-extract-plugin
export default {"topContainer":"faq_topContainer__+U78J","faqContainer":"faq_faqContainer__KxST+","ButtonContact":"faq_ButtonContact__9liWS","p1":"faq_p1__+IRix","p2":"faq_p2__QWQCL"};